import React, { useContext, useEffect, useState } from "react";
import { Badge, Button, Col, Row } from "react-bootstrap";
import Card from "src/components/Cards/Basic";
import Table from "src/components/Tables/Table";
import axios from "src/config/axios";
import history from "../../../../global/history";
import {
  faEye as DetailsIcon,
  faPencil as EditIcon,
  faEnvelope,
  faRightToBracket as faRightFrom,
} from "@fortawesome/free-solid-svg-icons";
import { dateTimeFormatterWithDay } from "src/global";
import TableIconButton from "src/components/UiComponents/Buttons/TableIconButton";
import { modifyState } from "src/components/UiComponents/Buttons/BackButton/helper";
import { Link, useLocation } from "react-router-dom";
import useFilter from "src/global/useFilter";
import moment from "moment";
import { useTranslation } from "react-i18next";
import BookingCheckoutDialog from "../../Bookings/StayDetailsPage/BookingCheckoutDialog";
import { showSuccessToast } from "src/components/Toasts";
import OnlineReservationDetailsDialog from "../../OnlineReservations/OnlineReservationDetailsDialog";
import DailyCheckinCard from "src/pages/Dashboard/DailyCheckin/Components/DailyCheckinCard/index.jsx";
import { DashboardContext } from "../../../../routes/DashboardRoutes";
import OrderButtonDropdown from "../../../../components/UiComponents/Buttons/OrderButtonDropdown";

const DailyCheckinPage = () => {
  const { settings } = useContext(DashboardContext);

  const getColumns = () => {
    let columns = [
      { value: "buyer", name: "Kontaktperson" },
      { value: "parking_slot", name: "Stellplatz" },
      { value: "booked_from", name: "Anreise" },
      { value: "booked_until", name: "Abreise" },
      { value: "actions", name: "Aktionen" },
    ];
    if (filter.card === "arrivals") {
      columns = [
        { value: "buyer", name: "Kontaktperson" },
        { value: "email", name: "Email" },
        { value: "phone", name: "Telefon" },
        { value: "parking_slot", name: "Stellplatz" },
        { value: "booked_from", name: "Anreise" },
        { value: "booked_until", name: "Abreise" },
        {
          value: "can_redeem_code",
          name: t("daily_checkin.reservation_code_redeemable"),
        },
        { value: "actions", name: "Aktionen" },
      ];
    }
    return columns;
  };
  let defaultCardvalues = [
    { id: "checkouts", title: "Ausstehende Checkouts", value: 0, active: true },
    { id: "timeouts", title: "Zeitüberschreitung", value: 0, active: false },
  ];

  const { t } = useTranslation("dashboard");
  const [checkoutStay, setCheckoutStay] = useState();
  const [arrivalReservationId, setArrivalReservationId] = useState();
  const [loading, setLoading] = useState(true);
  const [cardValues, setCardValues] = useState(defaultCardvalues);
  const [tableData, setTableData] = useState();
  const location = useLocation();
  const { pathname } = location;
  const { filter, setFilter } = useFilter(pathname, {
    date: moment(),
    card: "checkouts",
    order: "booked_until_asc",
  });

  function handleCheckoutSuccess() {
    applyFilter();
    showSuccessToast();
    setCheckoutStay(null);
  }

  function handleArrivalReservationSuccess() {
    applyFilter();
    setArrivalReservationId(null);
  }

  function handleContactEmail(booking) {
    window.location.href = `mailto:${booking.contact.email}`;
  }

  useEffect(() => {
    if (settings?.online_reservation?.enabled) {
      setCardValues((prev) => [
        ...prev,
        { id: "arrivals", title: "Anreisen", value: 0, active: false },
      ]);
    }

    if (settings?.business?.pricing_model === "parking") {
      setCardValues((prev) => [
        ...prev,
        {
          id: "checkins",
          title: "Check-ins ausständig",
          value: 0,
          active: false,
        },
      ]);
    }
  }, [settings]);

  function applyFilter() {
    if (!filter.date || !filter.date.isValid()) return;

    setLoading(true);

    if (filter.card === "checkouts") {
      axios
        .get("/api/v1/daily_checkins/remaining_checkouts.json", {
          params: filter,
        })
        .then((response) => {
          setTableData(response.data.entries);
          setLoading(false);
        });
    } else if (filter.card === "arrivals") {
      axios
        .get("/api/v1/daily_checkins/remaining_arrivals.json", {
          params: filter,
        })
        .then((response) => {
          setTableData(response.data.entries);
          setLoading(false);
        });
    } else if (filter.card === "checkins") {
      axios
        .get("/api/v1/daily_checkins/remaining_checkins.json", {
          params: filter,
        })
        .then((response) => {
          setTableData(response.data.entries);
          setLoading(false);
        });
    } else if (filter.card === "timeouts") {
      axios
        .get("/api/v1/daily_checkins/remaining_timeouts.json", {
          params: filter,
        })
        .then((response) => {
          setTableData(response.data.entries);
          setLoading(false);
        });
    }

    axios
      .get("/api/v1/daily_checkins/counts.json", {
        params: { date: filter.date },
      })
      .then((response) => {
        handleCardValue("checkouts", response.data.count.remaining_checkouts);
        handleCardValue("checkins", response.data.count.remaining_checkins);
        handleCardValue("arrivals", response.data.count.remaining_arrivals);
        handleCardValue("timeouts", response.data.count.remaining_timeouts);
      });
  }

  const handleCardValue = (id, value) => {
    const card = cardValues.find((card) => card.id === id);
    if (card) {
      card.value = value;
      setCardValues((prev) => {
        return prev.map((c) => {
          if (card.id === c.id) {
            return card;
          }
          return c;
        });
      });
    }
  };

  const handleCurrentCard = (card_id) => {
    setFilter({ ...filter, card: card_id });
  };

  const handleDateChange = (date) => {
    setFilter({ ...filter, date: moment(date) });
  };

  useEffect(() => {
    applyFilter();
  }, [filter, cardValues.length]);

  if (!tableData) {
    return <></>;
  }

  return (
    <>
      <div className="mb-3 daily-checkin">
        <Card
          title={
            <div className="d-flex flex-wrap w-100 justify-content-between align-items-center">
              <span>Tages-Check</span>
            </div>
          }
        >
          <Row>
            <Col md={6}>
              <div className={"d-flex"}>
                <OrderButtonDropdown
                  className="mr-2"
                  selected={filter.order}
                  orders={[
                    {
                      key: "booked_until_asc",
                      value: t("common:general.order.booked_until_asc"),
                    },
                    {
                      key: "booked_until_desc",
                      value: t("common:general.order.booked_until_desc"),
                    },
                    {
                      key: "parking_slot_asc",
                      value: t("common:general.order.parking_slot_asc"),
                    },
                    {
                      key: "parking_slot_desc",
                      value: t("common:general.order.parking_slot_desc"),
                    },
                  ]}
                  callback={(selected_value) => {
                    setFilter({
                      ...filter,
                      order: selected_value,
                    });
                  }}
                />
                <input
                  disabled={loading}
                  defaultValue={moment(filter.date).format(
                    moment.HTML5_FMT.DATE
                  )}
                  type="date"
                  onChange={(e) => {
                    handleDateChange(e.target.value);
                  }}
                ></input>
              </div>
            </Col>
          </Row>
          <Row className={"mt-4 mb-4"}>
            {cardValues.map((card) => (
              <Col key={card.id}>
                <DailyCheckinCard
                  title={card.title}
                  value={card.value}
                  active={card.id === filter.card}
                  handleClick={() => {
                    handleCurrentCard(card.id);
                  }}
                />
              </Col>
            ))}
          </Row>
          <Row>
            <div
              style={{ maxWidth: "100%", width: "100%" }}
              className="ui-table-container"
            >
              <Table
                columns={getColumns()}
                empty={!loading && tableData.length === 0}
                className="table"
                style={{ userSelect: "none" }}
              >
                {loading ? (
                  <>
                    {Array.from({ length: 10 }, (_, i) => (
                      <tr key={i}>
                        {getColumns().map((column) => (
                          <td key={column.value}>
                            <div className={"preview w-100px h-25px"}></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </>
                ) : (
                  <>
                    {tableData.map((booking) => (
                      <tr key={booking.id}>
                        <td>
                          {booking.contact.full_name || "Gast unbekannt"}
                          <br />
                          <Badge
                            pill
                            variant={
                              booking.state === "draft"
                                ? "secondary"
                                : "primary"
                            }
                            text="light"
                          >
                            {t(`booking.statuses.${booking.state}`)}
                          </Badge>
                        </td>
                        {filter.card === "arrivals" && (
                          <>
                            <td>{booking.contact.email}</td>
                            <td>{booking.contact.phone}</td>
                          </>
                        )}
                        <td>{booking?.parking_slot?.name || " "}</td>
                        <td>
                          {booking.booked_from
                            ? dateTimeFormatterWithDay(booking.booked_from)
                            : "-"}
                        </td>
                        <td>
                          {booking.booked_until
                            ? dateTimeFormatterWithDay(booking.booked_until)
                            : "-"}
                        </td>
                        {filter.card === "arrivals" && (
                          <td>
                            <Badge
                              variant={
                                booking.can_redeem_code ? "success" : "secondary"
                              }
                            >
                              {t(
                                `common:general.${booking.can_redeem_code ? "yes" : "no"}`
                              )}
                            </Badge>
                          </td>
                        )}
                        <td>
                          <Col>
                            <>
                              <Link
                                to={{
                                  pathname: `/dashboard/stays/${booking.stay_id}`,
                                  state: modifyState(
                                    history,
                                    location.pathname
                                  ),
                                }}
                              >
                                <TableIconButton
                                  icon={DetailsIcon}
                                  variant={"primary"}
                                  onClick={undefined}
                                />
                              </Link>
                              {(booking.state === "active" ||
                                booking.state === "finished") && (
                                <TableIconButton
                                  icon={faRightFrom}
                                  variant="primary"
                                  onClick={() =>
                                    setCheckoutStay(booking.stay)
                                  }
                                />
                              )}

                              {booking.contact.email && (
                                <TableIconButton
                                  icon={faEnvelope}
                                  variant={"primary"}
                                  onClick={() => handleContactEmail(booking)}
                                />
                              )}
                            </>
                          </Col>
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </Table>
            </div>
          </Row>
        </Card>
      </div>

      {checkoutStay && (
        <BookingCheckoutDialog
          stay={checkoutStay}
          handleClose={() => setCheckoutStay(null)}
          handleSubmit={handleCheckoutSuccess}
        />
      )}

      {arrivalReservationId && (
        <OnlineReservationDetailsDialog
          reservationBookingId={arrivalReservationId}
          handleClose={() => setArrivalReservationId(null)}
          handleSubmit={handleArrivalReservationSuccess}
        />
      )}
    </>
  );
};
export default DailyCheckinPage;
